module.exports = __webpack_public_path__ + "public/images/connect.fd97c4b462b4ac596de25266d9f41af9.svg";